import React, { useState } from "react";

import { LoginContainerFactoryImpl } from "../../../business";
import { AccountStrings } from "../../../business/core";
import { AccountContainerComponent } from "../components";

export const AuthPage: React.FC = () => {
  const [step, setStep] = useState(1);
  const cs = AccountStrings['PTBR'].login;

  const factory = new LoginContainerFactoryImpl(step, setStep);

  return (
    <AccountContainerComponent title={cs.title}>
      {factory.create()}
    </AccountContainerComponent>
  );
};
